// 全局方法
import Vue from 'vue'

import md5 from 'js-md5';

/*import langJson from "@/plugins/all.json"*/
//储存axios 请求语言
function setAxiosLang(lang) {
   let languageList = window.$nuxt.$store.state.languageList;
   for (var i = 0; i < languageList.length; i++) {
      if (languageList[i].link == lang) {
      }
   };
};

export function langTextFun(loca_lang, text) {
   var md5text = md5(text);
   if (langJson[loca_lang]) {
      let texts = langJson[loca_lang][md5text];
      if (texts) {
         return texts
      } else {
         return text
      }
   } else {
      return text;
   }
}
const $lang = {
   install(Vue) {
      //判断浏览器语言
      Vue.prototype.$langType = function () {
         return 'global';
         var loca_lang = JSON.parse(localStorage.getItem('poprun_language'));
         if (loca_lang == null) {
            loca_lang = 'global';
         } else {
            loca_lang = loca_lang.countryCode
         }
         let languageList = window.$nuxt.$store.state.languageList;
         let storeLang = JSON.stringify(languageList);

         if (loca_lang && storeLang.indexOf(loca_lang + '-') != -1) {
            //  setAxiosLang(loca_lang);
            return loca_lang;
         } else {
            var naviLang = ((navigator.language || navigator.browserLanguage).toLowerCase()).substring(0, 2);

            if (storeLang.indexOf(naviLang) != -1) {
               //   setAxiosLang(naviLang);
               return naviLang;
            } else {
               setAxiosLang('global');
               return 'global';
            }
         }
      };
      //判断浏览器语言文本转换
      Vue.prototype.$langText = function (text, type) {
         return text
         var md5text = md5(text);
         var returnTetx = function (str) {
            //type  1 首字母大写  2 大写 3 小写  undefined 默认
            if (type == 1) {
               return str.slice(0, 1).toUpperCase() + str.slice(1).toLowerCase();
            } else if (type == 2) {
               return str.toUpperCase()
            } else if (type == 3) {
               return str.toLowerCase()
            } else {
               return str;
            }
         }
         let loca_lang = JSON.parse(localStorage.getItem('poprun_language'));
         if (loca_lang == null) {
            loca_lang = 'global';
         } else {
            loca_lang = loca_lang.countryCode
         }
         if (langJson[loca_lang]) {
            let texts = langJson[loca_lang][md5text];
            if (texts) {
               return returnTetx(texts)
            } else {
               return returnTetx(langJson['global'][md5text])
            }
         } else {
            return returnTetx(langJson['global'][md5text]);
         }
      };

      Vue.prototype.$T = Vue.prototype.$langText
   }
}
Vue.use($lang);
